import {Pipe, PipeTransform} from "@angular/core";
import {PAYMENT_STATUS_TRANSLATES} from "../_maps/payment-statuses";

@Pipe({name: 'paymentStatus'})
export class PaymentStatusPipe implements PipeTransform {
  transform(status: string): any {
    return PAYMENT_STATUS_TRANSLATES[status] || '';
  }
}
